// 对局观测 · 时间线与事件：地点与物品名、当前场景、位置分布、事件时间线与事件种类。

import { asArray } from './run-records.js'

export function placeName(pack, id) {
  return asArray(pack.locations).find((item) => item.id === id)?.name || id || '—'
}

export function itemName(pack, id) {
  return asArray(pack.items).find((item) => item.id === id)?.name || id || '—'
}

/** 作品物品叠上当前状态里的位置与持有人。 */
export function currentItems(pack, state) {
  return asArray(pack.items).map((item) => ({ ...item, ...state?.items?.[item.id] }))
}

/** 玩家所在地点：在场人物、此处物品、此处最近五条已记录的变化（新的在前）。 */
export function currentScene(pack, branch) {
  const state = branch.state ?? {}
  const positions = state.positions ?? {}
  const location_id = positions[pack.player_id]
  const turn_count = asArray(branch.turns).length
  return {
    location: asArray(pack.locations).find((item) => item.id === location_id) ?? null,
    time: state.story_time || pack.narrative?.initial_time || null,
    people: asArray(pack.characters).filter((person) => positions[person.id] === location_id),
    items: currentItems(pack, state).filter((item) => item.location_id === location_id),
    changes: asArray(branch.events)
      .filter((event) => event.location_id === location_id && event.seq <= turn_count && event.text)
      .slice(-5)
      .reverse(),
  }
}

/** 每个地点与当前在那里的人物。 */
export function locationRows(pack, state) {
  return asArray(pack.locations).map((place) => ({
    ...place,
    people: asArray(pack.characters).filter((person) => state?.positions?.[person.id] === place.id),
  }))
}

/** 事件时间线：没有 event_id 的旧事件用轮次与下标补一个稳定键。 */
export function eventRows(branch) {
  return asArray(branch.events).map((event, index) => ({ ...event, event_id: event.event_id || `${event.seq || 0}-${index}`, index }))
}

/** 事件带来的变化种类：移动、故事时间、物品转移；三样都没有的（只有正文与见闻者）记为见闻。时间线按它挑图标。 */
export function eventKinds(event) {
  const kinds = []
  if (asArray(event.moves).length > 0) kinds.push('move')
  if (event.time) kinds.push('time')
  if (asArray(event.transfers).length > 0) kinds.push('transfer')
  if (kinds.length === 0) kinds.push('witness')
  return kinds
}
